export enum Gender {
  Masculine = 'Masculine',
  Feminine = 'Feminine'
}
